import { initLocationMap } from './locations.js';
import './assessment.js';
import './contact-source.js';

document.documentElement.classList.add('has-js');

initLocationMap();

const header = document.querySelector('[data-site-header]');
const nav = document.querySelector('[data-primary-nav]');
const toggle = document.querySelector('[data-nav-toggle]');

if (header) {
  const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 45 || !document.querySelector('.site-hero'));
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
}

if (nav && toggle) {
  const setOpen = (open) => {
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  };
  toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
  nav.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) setOpen(false);
  });
}

const facts = document.querySelector('.home-facts');
if (facts) {
  const slides = [...facts.querySelectorAll('.home-fact')];
  const controls = [...facts.querySelectorAll('[data-slide]')];
  let current = 0;
  let timer;
  let transitionTimer;
  const show = (index, animate = true) => {
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    if (next === current && slides[next].classList.contains('is-active')) return;
    clearTimeout(transitionTimer);
    slides.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
    const previous = current;
    current = next;
    facts.dataset.activeSlide = String(current);
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === current);
      slide.setAttribute('aria-hidden', String(i !== current));
      slide.inert = i !== current;
    });
    if (animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      slides[previous].classList.add('is-leaving');
      slides[current].classList.add('is-entering');
      transitionTimer = setTimeout(() => {
        slides[previous].classList.remove('is-leaving');
        slides[current].classList.remove('is-entering');
      }, 550);
    }
    controls.forEach((control, i) => {
      control.classList.toggle('is-active', i === current);
      control.setAttribute('aria-current', String(i === current));
    });
  };
  const start = () => {
    clearInterval(timer);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;
    timer = setInterval(() => show(current + 1), 5000);
  };
  controls.forEach((control, i) => control.addEventListener('click', () => {
    clearInterval(timer);
    show(Number(control.dataset.slide) || i);
    start();
  }));
  facts.addEventListener('mouseenter', () => clearInterval(timer));
  facts.addEventListener('mouseleave', start);
  show(0, false);
  start();
}

const reviewSort = document.querySelector('[data-reviews-sort]');
const reviewList = document.querySelector('[data-reviews-list]');
if (reviewSort && reviewList) {
  const reviews = [...reviewList.querySelectorAll('.review')];
  reviewSort.addEventListener('change', () => {
    const order = reviewSort.value;
    reviews.sort((a, b) => {
      if (order === 'highest') return Number(b.dataset.reviewStars) - Number(a.dataset.reviewStars) || Number(b.dataset.reviewDate) - Number(a.dataset.reviewDate);
      if (order === 'lowest') return Number(a.dataset.reviewStars) - Number(b.dataset.reviewStars) || Number(b.dataset.reviewDate) - Number(a.dataset.reviewDate);
      return Number(b.dataset.reviewDate) - Number(a.dataset.reviewDate);
    });
    reviewList.replaceChildren(...reviews);
  });
}
